import { create as baseCreate } from '../create';

export const create = (packageName: string, namespace: string) =>
  baseCreate(window.localStorage, packageName, namespace);
